module.exports = __webpack_public_path__ + "static/img/img-4-1.ce7930e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/img-4-1.jpg
// module id = wh4p
// module chunks = 0